"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.scss");
var ui_1 = require("@vidazoo/ui");
var components_1 = require("./components");
var _ = require("lodash");
var components_2 = require("../reporting/components");
var utils_1 = require("../../utils");
var ItemProp = function (_a) {
    var item = _a.item, prop = _a.prop;
    return item[prop];
};
var conditionalFn = function (condition, fn) { return condition && fn; };
var ReportingGrid = /** @class */ (function (_super) {
    tslib_1.__extends(ReportingGrid, _super);
    function ReportingGrid(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onTimezoneChange = function (timezone) {
            var setParam = _this.props.setParam;
            setParam("timezone", timezone);
        };
        _this.onFromChange = function (from) {
            var setParam = _this.props.setParam;
            setParam("from", from);
        };
        _this.onToChange = function (to) {
            var setParam = _this.props.setParam;
            setParam("to", to);
        };
        _this.onCompareFromChange = function (from) {
            var setParam = _this.props.setParam;
            setParam("compareFrom", from);
        };
        _this.onCompareToChange = function (to) {
            var setParam = _this.props.setParam;
            setParam("compareTo", to);
        };
        _this.onIsCompareChange = function (isCompare) {
            var setParam = _this.props.setParam;
            setParam("isCompare", isCompare);
        };
        _this.onAddDimension = function (value, label) {
            var pushReportParam = _this.props.pushReportParam;
            pushReportParam("groups", value, label);
        };
        _this.onAddMetric = function (value, label) {
            var pushReportParam = _this.props.pushReportParam;
            pushReportParam("fields", value, label);
        };
        _this.onDeleteDimension = function (value) {
            var removeReportParam = _this.props.removeReportParam;
            removeReportParam("groups", value);
        };
        _this.onDeleteMetric = function (value) {
            var removeReportParam = _this.props.removeReportParam;
            removeReportParam("fields", value);
        };
        _this.onOrderDimensions = function (dimensions) {
            var setParam = _this.props.setParam;
            setParam("groups", dimensions);
        };
        _this.onOrderMetrics = function (metrics) {
            var setParam = _this.props.setParam;
            setParam("fields", metrics);
        };
        _this.onAddConstraint = function () {
            var addConstraint = _this.props.addConstraint;
            addConstraint();
        };
        _this.setConstraintParam = function (constraint, key, value) {
            var setConstraintParam = _this.props.setConstraintParam;
            setConstraintParam(constraint, key, value);
        };
        _this.onDeleteConstraint = function (constraint) {
            var removeConstraint = _this.props.removeConstraint;
            removeConstraint(constraint);
        };
        _this.onAddFilter = function () {
            var addFilter = _this.props.addFilter;
            addFilter();
        };
        _this.onAddFilterValue = function (filter, value, label) {
            var pushFilterValue = _this.props.pushFilterValue;
            pushFilterValue(filter, value, label);
        };
        _this.onRemoveFilterValue = function (filter, value) {
            var removeFilterValue = _this.props.removeFilterValue;
            removeFilterValue(filter, value);
        };
        _this.onChangeFilter = function (filter, key, value) {
            var _a = _this.props, setFilterKey = _a.setFilterKey, setFilterParam = _a.setFilterParam, filters = _a.filters;
            if (key === "key") {
                setFilterKey(filter, value);
                var defaultValue = _.find(filters, function (group) { return filter.key === group.value; }).operators[0];
                setFilterParam(filter, "operator", defaultValue);
                return;
            }
            setFilterParam(filter, key, value);
        };
        _this.onDeleteFilter = function (filter) {
            var removeFilter = _this.props.removeFilter;
            removeFilter(filter);
        };
        _this.onPresetChange = function (preset) {
            var setPreset = _this.props.setPreset;
            setPreset(preset);
        };
        _this.onPeriodChange = function (period) {
            var setPeriod = _this.props.setPeriod;
            setPeriod(period);
        };
        _this.onGenerateReport = function () {
            _this.reloadReportData(true);
        };
        _this.onResetParams = function () {
            var resetParams = _this.props.resetParams;
            resetParams();
        };
        _this.onCopyLink = function () {
            var generateReportLink = _this.props.generateReportLink;
            generateReportLink();
        };
        _this.onDownloadCSV = function () {
            var downloadCSV = _this.props.downloadCSV;
            downloadCSV();
        };
        _this.onSaveScheduledReport = function () {
            var createScheduleReport = _this.props.createScheduleReport;
            createScheduleReport();
        };
        _this.toggleOfflineReportModal = function () {
            _this.setState({ showOfflineReportModal: !_this.state.showOfflineReportModal });
        };
        _this.togglePresetsModal = function () {
            var _a = _this.props, loadPresetReports = _a.loadPresetReports, isLoadingPresetReports = _a.isLoadingPresetReports;
            var nextState = {
                showPresetsModal: !_this.state.showPresetsModal
            };
            if (nextState.showPresetsModal && !isLoadingPresetReports) {
                loadPresetReports();
            }
            _this.setState(nextState);
        };
        _this.toggleCreatePresetModal = function () {
            _this.setState({ showCreatePresetModal: !_this.state.showCreatePresetModal });
        };
        _this.onSavePresetReport = function (preset) {
            var savePresetReport = _this.props.savePresetReport;
            savePresetReport(preset);
        };
        _this.onDeletePresetReport = function (preset) {
            var setPromptDeletePresetReport = _this.props.setPromptDeletePresetReport;
            setPromptDeletePresetReport(preset);
        };
        _this.onSelectPresetReport = function (preset) {
            var applyReportPreset = _this.props.applyReportPreset;
            _this.togglePresetsModal();
            applyReportPreset(preset);
        };
        _this.cancelDeletePresetReport = function () {
            var setPromptDeletePresetReport = _this.props.setPromptDeletePresetReport;
            setPromptDeletePresetReport(null);
        };
        _this.deletePresetReport = function () {
            var _a = _this.props, setPromptDeletePresetReport = _a.setPromptDeletePresetReport, deletePresetReport = _a.deletePresetReport, promptDeletePresetReport = _a.promptDeletePresetReport;
            deletePresetReport(promptDeletePresetReport._id);
            setPromptDeletePresetReport(null);
        };
        _this.setEditHistoryReport = function (item) {
            _this.setState({ editHistoryReport: item });
        };
        _this.onEditHistoryReport = function (e) {
            var value = utils_1.normalizeEventValue(e);
            _this.setState({ editHistoryReport: tslib_1.__assign({}, _this.state.editHistoryReport, { description: value }) });
        };
        _this.cancelEditHistoryReport = function () {
            _this.setState({ editHistoryReport: null });
        };
        _this.onUpdateEditHistoryReport = function () {
            _this.props.updateEditHistoryReport(_this.state.editHistoryReport._id, { description: _this.state.editHistoryReport.description });
        };
        _this.state = {
            showOfflineReportModal: false,
            showPresetsModal: false,
            showCreatePresetModal: false,
            editHistoryReport: null
        };
        _this.initialize();
        return _this;
    }
    ReportingGrid.prototype.initialize = function () {
        var _a = this.props, location = _a.location, initialize = _a.initialize;
        var search = location.search;
        initialize(location.search, !!search);
    };
    ReportingGrid.prototype.componentDidMount = function () {
        var _a = this.props, loadHistoryReportsItems = _a.loadHistoryReportsItems, startListenToReportHistoryIsReady = _a.startListenToReportHistoryIsReady, useReportHistory = _a.useReportHistory;
        if (useReportHistory) {
            loadHistoryReportsItems && loadHistoryReportsItems();
            startListenToReportHistoryIsReady && startListenToReportHistoryIsReady();
        }
    };
    ReportingGrid.prototype.componentDidUpdate = function () {
        var _a = this.props, useReportHistory = _a.useReportHistory, handleRouteChangeHistoryReport = _a.handleRouteChangeHistoryReport;
        (useReportHistory && handleRouteChangeHistoryReport) && handleRouteChangeHistoryReport();
    };
    ReportingGrid.prototype.reloadReportData = function (resetLoad) {
        if (resetLoad === void 0) { resetLoad = false; }
        var getReport = this.props.getReport;
        getReport(resetLoad);
    };
    ReportingGrid.prototype.renderHeader = function () {
        var _a = this.props, params = _a.params, customAction = _a.customAction, groups = _a.groups, fields = _a.fields, filters = _a.filters, isLoading = _a.isLoading, results = _a.results, title = _a.title, onSupportClick = _a.onSupportClick, minWindowWidthToGroupActions = _a.minWindowWidthToGroupActions, useExtendedTimezonePicker = _a.useExtendedTimezonePicker, isGenerateReportDisabled = _a.isGenerateReportDisabled, rollBackParams = _a.rollBackParams, onClearAllParams = _a.onClearAllParams, onMultiplePaste = _a.onMultiplePaste, onBackToHistoryReports = _a.onBackToHistoryReports, useReportHistory = _a.useReportHistory, selectedHistoryReport = _a.selectedHistoryReport;
        var allowCompare = this.props.allowCompare;
        allowCompare = allowCompare && (typeof allowCompare === "function" ? allowCompare() : allowCompare);
        return (React.createElement(components_2.ReportingHeader, { allowCompare: allowCompare, preset: params.time, fromDate: params.from, toDate: params.to, timezone: params.timezone, isCompare: params.isCompare, compareFromDate: params.compareFrom, compareToDate: params.compareTo, period: params.period, useExtendedTimezonePicker: useExtendedTimezonePicker, dimensions: groups, metrics: fields, filterDimensions: filters, selectedDimensions: params.groups, selectedMetrics: params.fields, filters: params.filters, constraints: params.constraints, title: title, onPresetChange: conditionalFn(this.props.setPreset, this.onPresetChange), onPeriodChange: conditionalFn(allowCompare, this.onPeriodChange), onTimezoneChange: this.onTimezoneChange, onFromChange: this.onFromChange, onToChange: this.onToChange, onCompareFromChange: this.onCompareFromChange, onCompareToChange: this.onCompareToChange, onIsCompareChange: this.onIsCompareChange, onAddDimension: this.onAddDimension, onAddMetric: this.onAddMetric, onDeleteDimension: this.onDeleteDimension, onDeleteMetric: this.onDeleteMetric, onOrderDimensions: this.onOrderDimensions, onOrderMetrics: this.onOrderMetrics, onReset: this.onResetParams, onGenerateReport: this.onGenerateReport, onAddConstraint: this.onAddConstraint, onChangeConstraint: this.setConstraintParam, onDeleteConstraint: this.onDeleteConstraint, onAddFilter: this.onAddFilter, onAddFilterValue: this.onAddFilterValue, onRemoveFilterValue: this.onRemoveFilterValue, onChangeFilter: this.onChangeFilter, onDeleteFilter: this.onDeleteFilter, disabled: isLoading || results.result.length === 0, onCopyLink: this.onCopyLink, onDownloadCSV: conditionalFn(this.props.downloadCSV, this.onDownloadCSV), onSaveScheduledReport: conditionalFn(this.props.createScheduleReport, this.onSaveScheduledReport), onPresetReport: conditionalFn(this.props.loadPresetReports, this.togglePresetsModal), onOfflineReport: conditionalFn(this.props.createLongReport, this.toggleOfflineReportModal), onSupportClick: onSupportClick, minWindowWidthToGroupActions: minWindowWidthToGroupActions, isGenerateReportDisabled: isGenerateReportDisabled, customAction: customAction, rollBackParams: rollBackParams, onClearAllParams: onClearAllParams, onMultiplePaste: onMultiplePaste, onBackToHistoryReports: onBackToHistoryReports, useReportHistory: useReportHistory, selectedHistoryReport: selectedHistoryReport }));
    };
    ReportingGrid.prototype.renderReportingHistory = function () {
        if (!this.props.useReportHistory) {
            return null;
        }
        if (this.props.isLoadingHistoryReports || this.props.historyReports.length === 0 || this.props.selectedHistoryReport) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(ui_1.Label, { className: theme.historyReportsLabel, weight: 600 }, "History Reports:"),
            React.createElement(components_2.ReportingHistory, { setEditHistoryReport: this.setEditHistoryReport, sortDirection: this.props.reportHistorySortDirection, setSearchQuery: this.props.reportHistorySetSearchQuery, sortBy: this.props.reportHistorySortBy, sort: this.props.reportHistorySort, searchQueries: this.props.reportHistorySearchQueries, items: this.props.historyReports, selectedValues: this.props.reportHistorySelectedValues, setColumnsWidth: this.props.reportHistorySetColumnsWidth, getColumnsWidth: this.props.reportHistoryGetColumnsWidth, getReportFromReportingHistoryUrls: this.props.getReportFromReportingHistoryUrls, setParamsFromHistoryReport: this.props.setParamsFromHistoryReport })));
    };
    ReportingGrid.prototype.renderEditHistoryReportModal = function () {
        if (!this.props.useReportHistory) {
            return null;
        }
        return (React.createElement(ui_1.Modal, { exitOnClickOutside: true, onClose: this.cancelEditHistoryReport, isOpen: !!this.state.editHistoryReport }, this.state.editHistoryReport ? (React.createElement("div", { className: theme.editHistoryModal },
            React.createElement(ui_1.FormInput, { style: { marginBottom: 10, minWidth: 400 }, className: theme.input, value: this.state.editHistoryReport.description, name: "description", placeholder: "Description", onChange: this.onEditHistoryReport, hideValidationMessage: true }),
            React.createElement("div", { className: theme.actions },
                React.createElement(ui_1.Button, { type: "button", uppercase: true, gray: true, medium: true, style: { marginRight: 10 }, onClick: this.cancelEditHistoryReport }, "Cancel"),
                React.createElement(ui_1.Button, { type: "button", uppercase: true, green: true, medium: true, onClick: this.onUpdateEditHistoryReport }, "Update")))) : null));
    };
    ReportingGrid.prototype.renderReport = function () {
        var _a = this.props, isLoading = _a.isLoading, results = _a.results, ui = _a.ui, searchQueries = _a.searchQueries, filteredResults = _a.filteredResults, loadMore = _a.loadMore, onSearch = _a.onSearch, onSort = _a.onSort, filteredTotal = _a.filteredTotal, quickConstraint = _a.quickConstraint, quickFilter = _a.quickFilter, getColumnsWidth = _a.getColumnsWidth, setColumnsWidth = _a.setColumnsWidth, reportingSumOnTop = _a.reportingSumOnTop, toggleReportingSumOnTop = _a.toggleReportingSumOnTop, headers = _a.headers, setTotalRows = _a.setTotalRows;
        if (isLoading || results.result.length === 0) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(ui_1.ScrollTo, { minY: 100 },
                React.createElement(ui_1.FloatButton, { iconName: "icon-arrow-up-small", bottom: 2.2, right: 5.6 })),
            React.createElement(components_1.ReportingList, { groups: results.groups, fields: results.fields, results: filteredResults, filteredTotal: filteredTotal, sortBy: ui.sortBy, sortDirection: ui.sortDirection, density: ui.density, page: ui.page, pageSize: ui.pageSize, loadMore: loadMore, onSearch: onSearch, onSort: onSort, searchQueries: searchQueries, quickConstraint: quickConstraint, quickFilter: quickFilter, getColumnsWidth: getColumnsWidth, setColumnsWidth: setColumnsWidth, reportingSumOnTop: reportingSumOnTop, toggleReportingSumOnTop: toggleReportingSumOnTop, headers: headers, setTotalRows: setTotalRows })));
    };
    ReportingGrid.prototype.renderPreReport = function () {
        var _a = this.props, isSearched = _a.isSearched, isLoading = _a.isLoading, error = _a.error, useReportHistory = _a.useReportHistory, isLoadingHistoryReports = _a.isLoadingHistoryReports, historyReports = _a.historyReports;
        if (useReportHistory) {
            if (!isSearched && !isLoading && !error && (!isLoadingHistoryReports && historyReports.length === 0)) {
                return (React.createElement("div", { className: theme.message },
                    React.createElement(components_2.ReportingEmptyMessage, null)));
            }
        }
        else {
            if (!isSearched && !isLoading && !error) {
                return (React.createElement("div", { className: theme.message },
                    React.createElement(components_2.ReportingEmptyMessage, null)));
            }
        }
        return null;
    };
    ReportingGrid.prototype.renderAfterSearch = function () {
        var _a = this.props, isSearched = _a.isSearched, isLoading = _a.isLoading, results = _a.results, error = _a.error;
        if (!isLoading && error && error.code) {
            switch (error.code) {
                case 700: // report_too_big
                    return (React.createElement("div", { className: theme.message },
                        React.createElement(components_2.ReportingReportTooBigMessage, { onOfflineReportButtonClick: conditionalFn(this.props.createLongReport, this.toggleOfflineReportModal) })));
                case 503: // service_unavailable
                case 408: // request_timeout
                    return (React.createElement("div", { className: theme.message },
                        React.createElement(components_2.ReportingServiceError, { onTryAgainButtonClick: this.onGenerateReport })));
            }
        }
        if (isSearched && !isLoading && results.result.length === 0) {
            return (React.createElement("div", { className: theme.message },
                React.createElement(components_2.ReportingNoResultsMessage, null)));
        }
        return null;
    };
    ReportingGrid.prototype.renderLoader = function () {
        var isLoading = this.props.isLoading;
        if (isLoading) {
            return (React.createElement("div", { className: theme.message },
                React.createElement(ui_1.Loader, { size: 1, gray: true, className: theme.loader }),
                React.createElement(ui_1.PageMessage, { small: true, title: "Generating report", description: "Please wait..." })));
        }
        return null;
    };
    ReportingGrid.prototype.render = function () {
        var _a = this.props, createLongReport = _a.createLongReport, createPresetReport = _a.createPresetReport, presetReports = _a.presetReports, isLoadingPresetReports = _a.isLoadingPresetReports, promptDeletePresetReport = _a.promptDeletePresetReport, title = _a.title, allowSharedPresets = _a.allowSharedPresets;
        var _b = this.state, showOfflineReportModal = _b.showOfflineReportModal, showPresetsModal = _b.showPresetsModal, showCreatePresetModal = _b.showCreatePresetModal;
        return (React.createElement(ui_1.PageContainer, { pageTitle: title, className: theme.reporting },
            this.renderHeader(),
            this.renderReport(),
            this.renderPreReport(),
            this.renderAfterSearch(),
            this.renderLoader(),
            this.renderEditHistoryReportModal(),
            this.renderReportingHistory(),
            React.createElement(components_2.NameFieldModal, { isOpen: showOfflineReportModal, onClose: this.toggleOfflineReportModal, label: "Name your offline report", onSubmit: createLongReport }),
            presetReports ? (React.createElement(components_2.PresetsModal, { allowShared: allowSharedPresets, presets: presetReports, isOpen: showPresetsModal, isLoading: isLoadingPresetReports, onClose: this.togglePresetsModal, onCreateReport: this.toggleCreatePresetModal, onSave: this.onSavePresetReport, onDelete: this.onDeletePresetReport, onSelect: this.onSelectPresetReport })) : null,
            React.createElement(components_2.NameFieldModal, { allowSharedPresets: allowSharedPresets, isOpen: showCreatePresetModal, onClose: this.toggleCreatePresetModal, label: "Name your preset report", submitText: "Create Preset", onSubmit: createPresetReport }),
            React.createElement(ui_1.Modal, { external: true, exitOnClickOutside: true, onClose: this.cancelDeletePresetReport, isOpen: !!promptDeletePresetReport },
                React.createElement(ui_1.ConfirmPopMessage, { red: true, title: "Delete Preset Report?", text: React.createElement("span", null,
                        "Are you sure you want to delete ",
                        promptDeletePresetReport ?
                            React.createElement(ui_1.Label, { weight: 600, block: false },
                                React.createElement(ItemProp, { item: promptDeletePresetReport, prop: "name" })) : "",
                        "?"), cancelText: "No, Cancel", confirmText: "Yes, Delete", onCancelClick: this.cancelDeletePresetReport, onConfirmClick: this.deletePresetReport }))));
    };
    ReportingGrid.defaultProps = {
        title: "Reporting",
        useReportHistory: false
    };
    return ReportingGrid;
}(React.Component));
exports.default = ReportingGrid;
